'use strict';


function __detectSessionID() {
    let sessionId = '';
    if (window.location.toString().match(/SESS_ID=(\d+)/)) {
        sessionId = RegExp.$1;
    }
    return sessionId;
}

let fancybox = {
    closeBtn: false,
    maxWidth: 960,
    helpers: {
        title: { type: 'inside' },
        overlay : {
            css : {
                'background' : 'rgba(0, 0, 0, 0.5)'
            }
        }
    }
};

let ajax = {
    type: 'post',
    url: '/json/',
    dataType: 'json',
    timeout: 10000,
    traditional: true,
    SESSION_ID: __detectSessionID()
};

let yaCounter = 'yaCounter000000';

let breakpoints = {
    xxl: Infinity,
    xl: 1440,
    l: 1280,
    m: 1024,
    s: 780,
    xs: 600,
    xxs: 420
};


let interfaceName = document.body.dataset['interface'];
let browserType = document.body.dataset['browser'];

let isMobile = (browserType === 'mobile');
let isTablet = (browserType === 'tablet');
let isDevice = (browserType === 'mobile' || browserType === 'tablet');
let isDesktop = (browserType === 'desktop');


export {
    fancybox,
    ajax,
    breakpoints,
    yaCounter,

    interfaceName,
    browserType,
    isTablet,
    isMobile,
    isDevice,
    isDesktop
};
